import Portal from "@material-ui/core/Portal"
import { useSnackbar } from "notistack"
import React, { useContext, useEffect, useRef, useState } from "react"

import RegistradorContext from "../../contexts/registradorContext"
import ServicosContext from "../../contexts/servicosContext"

import CadastrarCliente from "./components/CadastrarCliente"
import CadastrarEndereco from "./components/CadastrarEndereco"
import Cardapio from "./components/Cardapio"
import ClientesEncontrados from "./components/ClientesEncontrados"
import EditarCliente from "./components/EditarCliente"
import EnderecosEncontrados from "./components/EnderecosEncontrados"
import FinalizacaoPedido, { ObterPedido } from "./components/FinalizacaoPedido"
import FinalizarMesa from "./components/FinalizarMesa"
import FormasDePagamento from "./components/FormasDePagamento"
import MesasAbertas from "./components/MesasAbertas"
import ParteInicial from "./components/ParteInicial"
import VisualizarPedido from "./components/VisualizarPedido"

//FUNCTIONS \ REQUESTS

import { buscarestabelecimentos, BuscarFormaDePagamentos } from "../../services/integracao"

import {
    calcularValorAPartirDe,
    calcularValorTotal,
    carrinhoNovo,
    enderecoClienteNaLoja,
    enderecoRetiradaNoLocal,
} from "../../pages/RegistradorDePedidos/functions"

import {
    listarClientes,
    ListarEstabelecimentosPorEndereco,
    RegistrarLogErro,
} from "../../services/clientefiel"

import {
    buscarDescontoCliente,
    CadastrarUsuarioBasico,
    listarEnderecos,
} from "../../services/cliente"

//FILES
import "./styles.css"

//FRAMEWORK
import {
    Backdrop,
    Button,
    CircularProgress,
    Fab,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@material-ui/core"
import AppBar from "@material-ui/core/AppBar"
import CardActionArea from "@material-ui/core/CardActionArea"
import CardActions from "@material-ui/core/CardActions"
import CardMedia from "@material-ui/core/CardMedia"
import Container from "@material-ui/core/Container"
import Dialog from "@material-ui/core/Dialog"
import IconButton from "@material-ui/core/IconButton"
import Slide from "@material-ui/core/Slide"
import { makeStyles } from "@material-ui/core/styles"
import Toolbar from "@material-ui/core/Toolbar"
import Typography from "@material-ui/core/Typography"
import { Add as AddIcon } from "@material-ui/icons"
import CloseIcon from "@material-ui/icons/Close"
import { default as AlertFixo } from "@material-ui/lab/Alert"
import Skeleton from "@material-ui/lab/Skeleton"
import { Card, Col, Row } from "react-bootstrap"
import { obterCardapioRegistrador } from "../../services/cardapio"
import useAppStore from "../../stores/AppStore"
import useLoadingStore from "../../stores/LoadingStore"

const qz = require("qz-tray")

const useStyles = makeStyles(theme => ({
    fixed: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 1000,
    },
    fixedMesa: {
        position: "fixed",
        right: "2em",
        bottom: "2em",
        zIndex: 2000,
    },
    fixedMesaFechar: {
        position: "fixed",
        right: "2em",
        bottom: "7em",
        zIndex: 2000,
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    paper: {
        marginTop: theme.spacing(8),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    rootAlert: {
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(2),
        },
    },
    backdrop: {
        color: "#fff",
    },
    pos: {
        marginBottom: 12,
    },
    heading: {
        width: "100%",
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    rootList: {
        width: "100%!important",
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: "inline",
        width: "100%",
    },
    appBar: {
        position: "fixed",
    },
    appContainer: {
        paddingTop: "6em",
        backgroundColor: "#f4f4f4",
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    list: {
        width: 250,
    },
    fullList: {
        width: "auto",
    },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const numeroMesas = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26,
    27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
]
const listaRepeticao = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]

export function Loading(props) {
    const configuracoes = useAppStore(s => s.configuracoes)
    const loadingDeStore = useLoadingStore(s => s.loading)
    const { loading } = props
    const loadingFinal = loading ?? loadingDeStore

    if (!loadingFinal) return null

    return (
        <Portal>
            <Backdrop
                style={{
                    color: configuracoes?.user?.parametros?.corPrimaria,
                    zIndex: 2147483647,
                    pointerEvents: "all",
                    position: "fixed",
                }}
                open
            >
                <img
                    style={{ width: 40, position: "fixed", borderRadius: "100%" }}
                    src={
                        configuracoes?.user?.parametros?.estabelecimento?.urlLogo
                            ? configuracoes?.user?.parametros?.estabelecimento?.urlLogo
                            : ""
                    }
                    alt=""
                />
                <CircularProgress color="inherit" size={80} />
            </Backdrop>
        </Portal>
    )
}

export default function RegistradorDePedidos({ fecharRegistradorModal }) {
    const autorizacao = localStorage.getItem("chaveSistema")
    const mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    )

    const classes = useStyles()

    const params = new URLSearchParams(window.location.search)
    const iframe = JSON.parse(params.get("iframe"))

    const { handleAceitadorDePedidos, buscarParametros } = useContext(ServicosContext)

    const configuracoes = useAppStore(s => s.configuracoes)
    const atualizarConfiguracoes = useAppStore(s => s.atualizarConfiguracoes)

    const { enqueueSnackbar } = useSnackbar()

    const [valorDescontoManual, setValorDescontoManual] = React.useState(0.0)
    const [taxaServico, setTaxaServico] = useState(Number(localStorage.getItem("taxaServico")) ?? 0)
    const [descontoAtivo, setDescontoAtivo] = React.useState(false)
    const [descontoAtivoPagamento, setDescontoAtivoPagamento] = React.useState(false)
    const [ativoMinimoEntregaGratis, setAtivoMinimoEntregaGratis] = React.useState(true)
    const [impressorasQZ, setImpressorasQZ] = React.useState([])
    const setLoading = useLoadingStore(s => s.setLoading)
    const [openFormasDePagamento, setOpenFormasDePagamento] = React.useState(false)
    const [openFinalizacaoPedido, setOpenFinalizacaoPedido] = React.useState(false)
    const [loadingClientes, setLoadingClientes] = React.useState(false)
    const [openListaClientes, setOpenListaClientes] = React.useState(false)
    const [listaClientes, setListaClientes] = React.useState([])
    const [loadingEnderecos, setLoadingEnderecos] = React.useState(false)
    const [openListaEnderecos, setOpenListaEnderecos] = React.useState(false)
    const [listaEnderecos, setListaEnderecos] = React.useState([])
    const [openGerenciarMesa, setOpenGerenciarMesa] = React.useState(false)
    const [listaMesas, setListaMesas] = React.useState([])
    const [openGerenciarPedidosMesa, setOpenGerenciarPedidosMesa] = React.useState(false)
    const [pedidosDaMesa, setPedidosDaMesa] = React.useState({})
    const [openCadastroCliente, setOpenCadastroCliente] = React.useState(false)
    const [openCadastroEndereco, setOpenCadastroEndereco] = React.useState(false)
    const [loadingEstabelecimentos, setLoadingEstabelecimentos] = React.useState(false)
    const [openEstabelecimentoDisponiveis, setOpenEstabelecimentoDisponiveis] =
        React.useState(false)
    const [listaEstabelecimentosQueDisponiveis, setListaEstabelecimentosDisponiveis] =
        React.useState([])
    const [openCardapio, setOpenCardapio] = React.useState(false)
    const [loadingCardapio, setLoadingCardapio] = React.useState(false)
    const [cardapio, setCardapio] = React.useState({})
    const [informacoesParaBuscarCardapio, setInformacoesParaBuscarCardapio] = React.useState({
        idEndereco: null,
        idCliente: null,
        idEstabelecimento: null,
        token: "a~I?;;+_@!AL^",
    })
    const [produtoSelecionado, setProdutoSelecionado] = React.useState({})
    const [visualizarPedido, setVisualizarPedido] = React.useState({})

    const [editarCliente, setEditarCliente] = React.useState({})
    const [estabelecimentosDisponiveis, setEstabelecimentosDisponiveis] = React.useState([])
    const [carrinho, setCarrinho] = useState(carrinhoNovo())
    const [finalizarMesa, setFinalizarMesa] = useState(false)

    const isDelivery = carrinho?.tipoPedido !== 1 && carrinho?.tipoPedido !== 2 && carrinho?.end
    const isRetiradaNoLocal = carrinho?.tipoPedido === 1 ? true : false
    const isPedidoMesa = carrinho?.tipoPedido === 2 ? true : false
    const isFreteGratisMinimoEntrega =
        carrinho?.itens?.length > 0 &&
        cardapio?.minimoEntregaGratis < 999 &&
        cardapio?.minimoEntregaGratis > 0 &&
        carrinho.valorTotal > cardapio?.minimoEntregaGratis &&
        ativoMinimoEntregaGratis
    const isFreteGratisDesconto =
        descontoAtivo && cardapio.informacao && cardapio.informacao.includes("frete grátis")

    console.log("isPedidoMesa", isPedidoMesa)
    const alertStart = (msg, tipo) => {
        enqueueSnackbar(msg, { variant: tipo })
    }

    async function verPedido(pedido, mesa) {
        try {
            setVisualizarPedido({ ...pedido, mesa: mesa })
        } catch (error) {
            RegistrarLogErro(error, "verPedido")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const handleSelecionarEndereco = async (endereco, index) => {
        try {
            endereco.appNome = configuracoes.user?.parametros?.appNome
            console.log("||> handleSelecionarEndereco", endereco)
            setInformacoesParaBuscarCardapio({
                ...informacoesParaBuscarCardapio,
                idEndereco: endereco?.id,
            })
            setOpenEstabelecimentoDisponiveis(true)
            setLoadingEstabelecimentos(true)
            endereco.token = "a~I?;;+_@!AL^"

            if (configuracoes.user.parametros.tipoEntregaBairro == 1) {
                endereco.bairroEspecifico = 1
            } else {
                endereco.bairroEspecifico = 0
            }

            const response = await ListarEstabelecimentosPorEndereco(autorizacao, endereco)

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            const estabelecimentosDoUsuario = response.filter(e => {
                return estabelecimentosDisponiveis.filter(ee => ee?.id == e?.id).length
            })

            const estabelecimentos = estabelecimentosDoUsuario.filter(
                loja => loja.possuiEnderecoAtendido === true
            )

            const cart = Object.assign({}, carrinho)
            cart.end = endereco

            cart.tipoPedido = 0

            listaEnderecos[index] = endereco

            setCarrinho(
                calcularValorTotal({
                    descontoAtivoPagamento,
                    carrinho: cart,
                    cardapio,
                    descontoAtivo: false,
                    isDelivery,
                    ativoMinimoEntregaGratis,
                    valorDescontoManual,
                    taxaServico,
                    descontoCliente,
                })
            )
            if (estabelecimentos.length === 1) {
                handleSelecionarEstabelecimento(estabelecimentos[0], cart)
            }

            setListaEstabelecimentosDisponiveis(estabelecimentos)
            setLoadingEstabelecimentos(false)
        } catch (error) {
            RegistrarLogErro(error, "selecionouBairroSelect")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const handleSelecionarEstabelecimento = (estabelecimento, carrinho) => {
        try {
            console.log("||> handleSelecionarEstabelecimento", estabelecimento, carrinho)
            const infos = {
                ...informacoesParaBuscarCardapio,
                idEstabelecimento: estabelecimento.id,
            }
            setInformacoesParaBuscarCardapio(infos)
            const cart = Object.assign({}, carrinho)
            cart.estabelecimento = estabelecimento
            if (estabelecimentosDisponiveis.length > 1) {
                cart.end.taxaEntrega = estabelecimento?.taxaEntrega
            }

            const cardapio = handleBuscarCardapio({ infos, cart })

            setCarrinho(
                calcularValorTotal({
                    descontoAtivoPagamento,
                    carrinho: cart,
                    cardapio,
                    descontoAtivo: false,
                    isDelivery,
                    ativoMinimoEntregaGratis,
                    valorDescontoManual,
                    taxaServico: taxaServico,
                    descontoCliente,
                })
            )
        } catch (error) {
            RegistrarLogErro(error, "handleSelecionarEstabelecimento")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const handleBuscarDadosEstabelecimentos = async () => {
        try {
            const response = await buscarestabelecimentos(autorizacao)
            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }
            setEstabelecimentosDisponiveis(response)
            setLoading(false)
        } catch (error) {
            RegistrarLogErro(error, "handleBuscarDadosEstabelecimentos")
        }
        return {}
    }

    const [cliente, setCliente] = useState(false)
    const [descontoCliente, setDescontoCliente] = useState(null)

    const handleSelecionarCliente = async cliente => {
        setCliente(true)
        try {
            const responseDescontoCliente = await buscarDescontoCliente(
                cliente.id,
                configuracoes.user.parametros.estabelecimento.id,
                autorizacao
            )
            setDescontoCliente(responseDescontoCliente)

            console.log("||> handleSelecionarCliente", cliente)
            setInformacoesParaBuscarCardapio({
                ...informacoesParaBuscarCardapio,
                idCliente: cliente.id,
            })
            setOpenListaEnderecos(true)
            setLoadingEnderecos(true)
            const data = {
                idCliente: cliente.id,
                idEstabelecimento: configuracoes.user.parametros.estabelecimento.id,
                token: "a~I?;;+_@!AL^",
            }
            const response = await listarEnderecos(
                autorizacao,
                data,
                configuracoes.user?.parametros?.appNome
            )

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return false
            }

            const cart = Object.assign({}, carrinho)

            const objClientePedido = {
                id: cliente.id,
                telefone: cliente.telefone,
                nome: cliente.nome,
            }

            cart.cliente = objClientePedido
            setCarrinho(
                calcularValorTotal({
                    descontoAtivoPagamento,
                    carrinho: cart,
                    cardapio,
                    descontoAtivo: false,
                    isDelivery,
                    ativoMinimoEntregaGratis,
                    valorDescontoManual,
                    taxaServico: taxaServico,
                    descontoCliente,
                })
            )

            setListaEnderecos(response)
            setLoadingEnderecos(false)
        } catch (error) {
            RegistrarLogErro(error, "handleSelecionarCliente")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const verificarSeTemQZ = () => {
        try {
            if (qz.websocket.isActive()) {
                buscarImpressoras()
            } else {
                qz.websocket
                    .connect()
                    .then(() => {
                        qz.printers
                            .details()
                            .then(function (data) {
                                for (var i = 0; i < data.length; i++) {
                                    console.log(
                                        data[i].name +
                                            " " +
                                            data[i].driver +
                                            " " +
                                            data[i].density +
                                            " " +
                                            data[i].trays
                                    )
                                }
                            })
                            .catch(function (e) {
                                console.error(e)
                            })

                        //console.log('Conectado QZ!');
                        buscarImpressoras()
                    })
                    .catch(err => {
                        console.error("Erro QZ", err.message)
                        // alertStart("Impressao automatica não identifica!", "error")
                        if (impressorasQZ.length > 0) {
                            setImpressorasQZ([])
                        }
                    })
            }
        } catch (error) {
            RegistrarLogErro(error, "verificarSeTemQZ")
        }
    }

    useEffect(() => {
        try {
            verificarSeTemQZ()
            handleBuscarDadosEstabelecimentos()
        } catch (error) {
            RegistrarLogErro(error, "useEffect")
        }
    }, [])

    const buscarImpressoras = async () => {
        try {
            // TODO:
            // if (!configuracoes.printer?.impressoras?.length) {
            //     configuracoes.printer.impressoras = [await qz.printers.getDefault()]
            //     atualizarConfiguracoes(configuracoes)
            //     // localStorage.setItem("configuracoes", JSON.stringify(configuracoes))
            // }

            const printers = await qz.printers.find()
            setImpressorasQZ(printers)
        } catch (error) {
            RegistrarLogErro(error, "buscarImpressoras")
        }
    }

    const realizarPedidoMesa = pedido => {
        try {
            console.log("||> realizarPedidoMesa", pedido)
            const cart = Object.assign({}, carrinho)
            cart.status = 99
            cart.tipoPedido = 2
            cart.end = enderecoClienteNaLoja()
            cart.cliente = pedido.cliente
            cart.estabelecimento = pedido.estabelecimento
            cart.mesa = pedido.mesa

            const infos = {
                ...informacoesParaBuscarCardapio,
                idEstabelecimento: pedido.estabelecimento.id,
                idCliente: pedido.cliente.id,
            }
            setInformacoesParaBuscarCardapio(infos)

            setPedidosDaMesa({})
            setOpenGerenciarPedidosMesa(false)
            setOpenGerenciarMesa(false)

            const cardapio = handleBuscarCardapio({ infos, cart })

            setCarrinho(
                calcularValorTotal({
                    descontoAtivoPagamento,
                    carrinho: cart,
                    cardapio,
                    descontoAtivo,
                    isDelivery,
                    ativoMinimoEntregaGratis,
                    valorDescontoManual,
                    taxaServico: taxaServico,
                    descontoCliente,
                })
            )
        } catch (error) {
            RegistrarLogErro(error, "realizarPedidoMesa")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const handleBuscarCardapio = async ({ infos }) => {
        try {
            console.log("||> handleBuscarCardapio", infos)
            setLoadingCardapio(true)
            setOpenCardapio(true)
            setOpenEstabelecimentoDisponiveis(false)
            setOpenListaEnderecos(false)
            setOpenListaClientes(false)

            setListaClientes([])
            setListaEnderecos([])
            setListaEstabelecimentosDisponiveis([])

            infos.idCliente = null
            infos.idEndereco = null

            let response = null

            response = await obterCardapioRegistrador(infos.idEstabelecimento, autorizacao)
            response.formaPagamento = await BuscarFormaDePagamentos(infos.idEstabelecimento)

            console.log("ObterCardapioCompleto", response)
            if (response.retornoErro) {
                localStorage.removeItem("cardapio-mesa")
                alertStart(response.mensagem, "error")
                return false
            }

            response.categorias.forEach(categoria => {
                categoria.produtos.forEach(produto => {
                    produto.valorRealCalculado = calcularValorAPartirDe(produto)
                    produto.valorDeCalculado = calcularValorAPartirDe(produto, true)
                })
            })

            if (estabelecimentosDisponiveis.length === 1) {
                handleToggleParteInicial()
            }

            setCardapio(response)
            setLoadingCardapio(false)
            return response
        } catch (error) {
            console.error(error)
            RegistrarLogErro(error, "handleBuscarCardapio")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
        return {}
    }

    const handleCloseEstabelecimentoQueEntregam = () => {
        try {
            setOpenEstabelecimentoDisponiveis(false)
            setListaEstabelecimentosDisponiveis([])
        } catch (error) {
            RegistrarLogErro(error, "handleCloseCardapio")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    function ativarDesativarDesconto() {
        try {
            const ativo = !descontoAtivo
            setValorDescontoManual(0.0)
            setDescontoAtivo(ativo)
            setCarrinho(
                calcularValorTotal({
                    descontoAtivoPagamento,
                    carrinho,
                    cardapio,
                    descontoAtivo: ativo,
                    isDelivery,
                    ativoMinimoEntregaGratis,
                    valorDescontoManual: 0.0,
                    taxaServico: taxaServico,
                    descontoCliente,
                })
            )
        } catch (error) {
            RegistrarLogErro(error, "ativarDesativarDesconto")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    function ativarDesativarDescontoPagamento() {
        try {
            const ativo = !descontoAtivoPagamento
            setValorDescontoManual(0.0)
            setDescontoAtivoPagamento(ativo)
            setCarrinho(
                calcularValorTotal({
                    descontoAtivoPagamento: ativo,
                    carrinho,
                    cardapio,
                    descontoAtivo,
                    isDelivery,
                    ativoMinimoEntregaGratis,
                    valorDescontoManual: 0.0,
                    taxaServico,
                    descontoCliente,
                })
            )
        } catch (error) {
            RegistrarLogErro(error, "ativarDesativarDescontoPagamento")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    function calcularValorTotalPedido(cart) {
        try {
            setCarrinho(prev =>
                calcularValorTotal({
                    descontoAtivoPagamento,
                    carrinho: prev.estabelecimento ? prev : cart,
                    cardapio,
                    descontoAtivo,
                    isDelivery: true,
                    ativoMinimoEntregaGratis,
                    valorDescontoManual: 0.0,
                    taxaServico,
                    descontoCliente,
                })
            )
        } catch (error) {
            RegistrarLogErro(error, "calcularValorTotalPedido")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    function ativarMinimoEntregaGratis() {
        try {
            const ativo = !ativoMinimoEntregaGratis
            setAtivoMinimoEntregaGratis(ativo)
            setCarrinho(
                calcularValorTotal({
                    descontoAtivoPagamento,
                    carrinho,
                    cardapio,
                    descontoAtivo,
                    isDelivery,
                    ativoMinimoEntregaGratis: ativo,
                    valorDescontoManual,
                    taxaServico: taxaServico,
                    descontoCliente,
                })
            )
        } catch (error) {
            RegistrarLogErro(error, "ativarMinimoEntregaGratis")
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
        }
    }

    const verificarExistente = async valor => {
        try {
            const idEstabelecimento =
                configuracoes?.user?.parametros?.estabelecimento?.id ??
                (await buscarParametros()).estabelecimento.id

            const data = {
                idEstabelecimento,
                nomeCliente: valor
                    .replace("(", "")
                    .replace(")", "")
                    .replace("-", "")
                    .replace(" ", ""),
                maxResultado: 100,
                token: "a~I?;;+_@!AL^",
            }

            const response = await listarClientes(autorizacao, data)

            if (response.retornoErro) {
                alertStart(response.mensagem, "error")
                return []
            }

            return response
        } catch (error) {
            RegistrarLogErro(error, "verificarExistente", { valor })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
            console.error(error)
        }
    }

    const cadastrarUsuario = async e => {
        try {
            e.preventDefault()
            if (document.getElementById("nome-cadastro")?.value === "") {
                alertStart("Nome do cliente é necessário.", "error")
                return false
            } else if (document.getElementById("telefone-cadastro")?.value === "") {
                alertStart("Telefone do cliente é necessário.", "error")
                return false
            }

            const usuariosExistentes = await verificarExistente(
                document.getElementById("telefone-cadastro").value
            )

            if (usuariosExistentes.length) {
                setListaClientes(usuariosExistentes)
                setOpenListaClientes(true)
                setOpenCadastroCliente(false)
                alertStart("Já existe usuário com esse telefone", "warning")
                return false
            }

            const data = {
                appNome: configuracoes.user?.parametros?.appNome,
                tipoUsuario: 3, //0-permanente, 1-temporario/semcadastro, 2-temporario/mesa, 3-temporario/registrador
                nome: document.getElementById("nome-cadastro")?.value,
                telefone: document.getElementById("telefone-cadastro")?.value,
                token: `${process.env.REACT_APP_CLIENTEFIEL_TOKEN}`,
            }

            setLoading(true)
            setOpenCadastroCliente(false)

            const retornoUsuario = await CadastrarUsuarioBasico(autorizacao, data)
            if (retornoUsuario.retornoErro) {
                //algum erro EstabelecimentoAberto
                alertStart(retornoUsuario.mensagem, "error")
            } else {
                // document.getElementById('nome-cadastro').value = ''
                // document.getElementById('telefone-cadastro').value = ''
                handleSelecionarCliente(retornoUsuario)
                alertStart("Usuário Cadastrado com sucesso.", "success")
            }
        } catch (error) {
            RegistrarLogErro(error, "cadastrarUsuario", {
                appNome: configuracoes.user?.parametros?.appNome,
                nomeCadastro: document.getElementById("nome-cadastro")?.value,
                telefoneCadastro: document.getElementById("telefone-cadastro")?.value,
            })
            alertStart("Procure os desenvolvedores! Erro: " + error.message, "error")
            console.error(error)
        }
        setLoading(false)
    }

    const [openParteInicial, setOpenParteInicial] = useState(false)
    const handleToggleParteInicial = () => {
        setOpenParteInicial(prev => !prev)
    }

    const buscarEstabelecimento = () => {
        if (!estabelecimentosDisponiveis || estabelecimentosDisponiveis.length === 0) return

        const cart = carrinhoNovo()
        setCarrinho(cart)

        if (estabelecimentosDisponiveis.length > 1) {
            handleToggleParteInicial()
        } else {
            handleSelecionarEstabelecimento(estabelecimentosDisponiveis[0], cart)
        }
    }

    useEffect(() => {
        buscarEstabelecimento()
    }, [estabelecimentosDisponiveis])

    useEffect(() => {
        const novo = calcularValorTotal({
            descontoAtivoPagamento,
            carrinho,
            cardapio,
            descontoAtivo,
            isDelivery,
            ativoMinimoEntregaGratis,
            valorDescontoManual,
            taxaServico,
            descontoCliente,
        })

        if (novo.valorTotal !== carrinho.valorTotal) {
            setCarrinho(novo)
        }
    }, [carrinho])

    const handleCloseGerenciamentoPedidosMesa = () => setOpenGerenciarPedidosMesa(false)

    const mesaURL = new URLSearchParams(window.location.search).get("mesa")
    const [mesa, setMesa] = useState(Number(mesaURL) ? mesaURL : null)
    const idPedidoURL = new URLSearchParams(window.location.search).get("idPedido")
    const [idPedido] = useState(idPedidoURL ? Number(idPedidoURL) : null)

    const [cpfNaNota, setCpfNaNota] = useState("")
    const [nome, setNome] = useState(null)
    const [telefone, setTelefone] = useState(null)
    const [observacao, setObservacao] = useState(null)
    const [pagamentoEditar, setPagamentoEditar] = useState(null)

    const tratouEdicaoRef = useRef(false)

    const handleEditarPedido = async () => {
        if (!idPedido || tratouEdicaoRef.current) return
        tratouEdicaoRef.current = true
        try {
            const pedido = await ObterPedido(idPedido)
            if (!pedido) return
            const cart = Object.assign({}, carrinho)
            cart.status = 99
            cart.tipoPedido = Number.isFinite(pedido?.tipoPedido) ? pedido.tipoPedido : 0

            if (cart.tipoPedido === 1) {
                cart.end = enderecoRetiradaNoLocal()
            } else if (cart.tipoPedido === 2) {
                cart.end = enderecoClienteNaLoja()
            } else {
                if (pedido?.end) cart.end = pedido.end
            }

            if (pedido?.cliente) {
                cart.cliente = {
                    id: pedido.cliente.id,
                    nome: pedido.cliente.nome,
                    telefone: pedido.cliente.telefone,
                }
            }
            setCarrinho(cart)

            const estPedido =
                pedido?.estabelecimento ||
                estabelecimentosDisponiveis.find(e => e.id === pedido?.idEstabelecimento)
            if (estPedido) {
                handleSelecionarEstabelecimento(estPedido, cart)
                return
            }

            if (cart.tipoPedido === 0 && !pedido?.end) {
                setOpenListaEnderecos(true)
                setLoadingEnderecos(false)
                return
            }

            if (cart.tipoPedido === 0 && cart.end) {
                await handleSelecionarEndereco(cart.end, 0)
                return
            }

            setOpenEstabelecimentoDisponiveis(true)
            setLoadingEstabelecimentos(true)
        } catch (error) {
            RegistrarLogErro(error, "handleEditarPedido[Index]")
            alertStart("Erro ao carregar pedido para edição.", "error")
        }
    }

    useEffect(() => {
        if (!idPedido) return
        ;(async () => {
            const data = await ObterPedido(idPedido)
            setTelefone(data?.telefoneCliente || null)
            setNome(data?.nomePedido || null)
            setMesa(data?.numeroMesa || null)
            setCpfNaNota(data?.cpfTitular || null)
            setObservacao(data?.observacao || null)
            setPagamentoEditar(data?.formaPagamento || null)
        })()
    }, [idPedido])

    useEffect(() => {
        const pronto = estabelecimentosDisponiveis && estabelecimentosDisponiveis.length > 0
        if (!pronto) return
        handleEditarPedido()
    }, [estabelecimentosDisponiveis.length])

    return (
        <RegistradorContext.Provider
            value={{
                openParteInicial,
                handleToggleParteInicial,

                fecharRegistradorModal,
                descontoAtivoPagamento,
                setDescontoAtivoPagamento,
                ativarDesativarDescontoPagamento,
                calcularValorTotalPedido,
                pedidosDaMesa,
                handleBuscarCardapio,
                finalizarMesa,
                handleSelecionarEstabelecimento,
                impressorasQZ,
                visualizarPedido,
                setProdutoSelecionado,
                enderecoRetiradaNoLocal,
                visualizarPedido,
                setVisualizarPedido,
                loadingCardapio,
                setLoadingCardapio,
                openCardapio,
                setOpenCardapio,
                produtoSelecionado,
                setCardapio,
                setOpenFinalizacaoPedido,
                openFinalizacaoPedido,
                isPedidoMesa,
                numeroMesas,
                isRetiradaNoLocal,
                setOpenFormasDePagamento,
                openFormasDePagamento,
                ativarDesativarDesconto,
                ativoMinimoEntregaGratis,
                ativarMinimoEntregaGratis,
                setFinalizarMesa,
                setOpenCadastroEndereco,
                openCadastroEndereco,
                isDelivery,
                carrinho,
                descontoAtivo,
                setDescontoAtivo,
                isFreteGratisMinimoEntrega,
                cardapio,
                setCarrinho,
                setLoadingClientes,
                setOpenListaClientes,
                setListaClientes,
                listaEnderecos,
                openListaEnderecos,
                setOpenListaEnderecos,
                setOpenGerenciarMesa,
                setListaMesas,
                listaMesas,
                valorDescontoManual,
                setValorDescontoManual,
                taxaServico,
                setTaxaServico,
                openListaClientes,
                loadingClientes,
                listaClientes,
                listaRepeticao,
                setInformacoesParaBuscarCardapio,
                setListaEstabelecimentosDisponiveis,
                informacoesParaBuscarCardapio,
                setLoadingEnderecos,
                loadingEnderecos,
                handleSelecionarCliente,
                setEditarCliente,
                isFreteGratisDesconto,
                setOpenCadastroCliente,
                cadastrarUsuario,
                openCadastroCliente,
                setPedidosDaMesa,
                setOpenGerenciarPedidosMesa,
                openGerenciarMesa,

                editarCliente,
                setEditarCliente,
                setListaEnderecos,
                isDelivery,

                setLoadingEstabelecimentos,
                estabelecimentosDisponiveis,
                setOpenEstabelecimentoDisponiveis,

                cliente,
                setCliente,

                handleSelecionarEndereco,

                buscarEstabelecimento,
                mesa,
                setMesa,
                cpfNaNota,
                setCpfNaNota,
                nome,
                telefone,
                observacao,
                pagamentoEditar,
                idPedido,

                descontoCliente,
            }}
        >
            <Loading />
            <Container component="main" className="container-buscando">
                {openGerenciarPedidosMesa && (
                    <Dialog
                        fullScreen
                        open={openGerenciarPedidosMesa}
                        onClose={handleCloseGerenciamentoPedidosMesa}
                        TransitionComponent={Transition}
                    >
                        <AppBar className={classes.appBar}>
                            <Toolbar>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={handleCloseGerenciamentoPedidosMesa}
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" className={classes.title}>
                                    ({pedidosDaMesa?.pedidosMesa?.length}) Pedidos Encontrados
                                </Typography>

                                {!mobile ? (
                                    <Row>
                                        <Col xs={12} md={12} lg={12} style={{ margin: "0.5em 0" }}>
                                            {impressorasQZ.length > 0 ? (
                                                <React.Fragment>
                                                    <FormControl
                                                        variant="outlined"
                                                        className={classes.formControl}
                                                        style={{ width: "100%" }}
                                                    >
                                                        <InputLabel
                                                            id="impressoras"
                                                            style={{
                                                                background: "white",
                                                                "border-radius": "10px",
                                                                padding: "2px 10px",
                                                            }}
                                                        >
                                                            Imprimir 1º Opção
                                                        </InputLabel>
                                                        <Select
                                                            fullWidth
                                                            labelId="Impressora-P-Imprimir"
                                                            id="Impressora-P-Imprimir"
                                                            defaultValue={
                                                                configuracoes.printer.impressora
                                                                    ? configuracoes.printer
                                                                          .impressora
                                                                    : "vazio"
                                                            }
                                                            style={{
                                                                width: "200px",
                                                                background: "white",
                                                            }}
                                                            onChange={e =>
                                                                atualizarConfiguracoes({
                                                                    printers: {
                                                                        impressora: e.target.value,
                                                                    },
                                                                })
                                                            }
                                                            label="Impressora P/ Imprimir"
                                                        >
                                                            <MenuItem value="vazio">
                                                                <em>Nenhuma</em>
                                                            </MenuItem>

                                                            {impressorasQZ.map((printer, index) => (
                                                                <MenuItem
                                                                    key={index}
                                                                    value={printer}
                                                                >
                                                                    {printer}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </FormControl>
                                                </React.Fragment>
                                            ) : (
                                                <>
                                                    <Button
                                                        onClick={e => {
                                                            verificarSeTemQZ()
                                                        }}
                                                        variant="contained"
                                                        style={{
                                                            backgroundColor: "#6c757d",
                                                            color: "white",
                                                        }}
                                                    >
                                                        Identificar Printer
                                                    </Button>

                                                    <Button
                                                        onClick={e => {
                                                            window.location.href =
                                                                "https://clientefielsp.s3-sa-east-1.amazonaws.com/Cliente+Fiel+Printer.zip"
                                                        }}
                                                        variant="contained"
                                                        style={{
                                                            marginLeft: "10px",
                                                            backgroundColor: "#6c757d",
                                                            color: "white",
                                                        }}
                                                    >
                                                        Download Printer
                                                    </Button>
                                                </>
                                            )}
                                        </Col>
                                    </Row>
                                ) : null}
                            </Toolbar>
                        </AppBar>
                        <Container className={classes.appContainer}>
                            <Row>
                                <Col
                                    xs={12}
                                    md={12}
                                    lg={12}
                                    style={{ marginBottom: "0.5em", textAlign: "center" }}
                                >
                                    <Fab
                                        variant="extended"
                                        aria-label="add"
                                        style={{ background: "#dc3545", color: "white" }}
                                        className={classes.fixedMesaFechar}
                                        onClick={() => {
                                            setFinalizarMesa(true)
                                        }}
                                    >
                                        <CloseIcon style={{ marginRight: "5px" }} />
                                        Fechar Mesa
                                    </Fab>

                                    <Fab
                                        variant="extended"
                                        aria-label="add"
                                        style={{ background: "#28a745", color: "white" }}
                                        className={classes.fixedMesa}
                                        onClick={() => {
                                            realizarPedidoMesa(
                                                pedidosDaMesa?.pedidosMesa[
                                                    pedidosDaMesa.pedidosMesa.length - 1
                                                ]
                                            )
                                        }}
                                    >
                                        <AddIcon style={{ marginRight: "5px" }} />
                                        Adicionar Pedido
                                    </Fab>

                                    {/* <Button size="small" onClick={() => {realizarPedidoMesa(pedidosDaMesa?.pedidosMesa[pedidosDaMesa.pedidosMesa.length-1])}} style={{"color":"#28a745"}}>
                        REALIZAR PEDIDO
                    </Button> */}
                                </Col>

                                {pedidosDaMesa?.pedidosMesa?.map((pedido, index) => (
                                    <Col
                                        xs={12}
                                        md={6}
                                        lg={4}
                                        key={index}
                                        style={{ marginBottom: "0.5em" }}
                                    >
                                        <Card className={classes.root} style={{ height: "100%" }}>
                                            <CardActionArea
                                                onClick={() => {
                                                    verPedido(pedido, pedidosDaMesa.numeroMesa)
                                                }}
                                                style={{
                                                    height: "calc(100% - 30px)",
                                                    flexFlow: "column-reverse",
                                                    alignItems: "normal",
                                                }}
                                            >
                                                <Row
                                                    style={{
                                                        margin: 0,
                                                        textAlign: "",
                                                        width: "100%",
                                                        padding: "1em",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Col
                                                        xs={3}
                                                        md={3}
                                                        lg={3}
                                                        style={{
                                                            padding: 0,
                                                            textAlign: "center",
                                                            fontSize: "5em",
                                                        }}
                                                    >
                                                        {index + 1}º
                                                    </Col>
                                                    <Col xs={9} md={9} lg={9}>
                                                        <Typography
                                                            variant="body2"
                                                            color="textSecondary"
                                                            component="p"
                                                        >
                                                            {pedido.strDataRealizacao}
                                                        </Typography>

                                                        <Typography gutterBottom component="h2">
                                                            {pedido.cliente?.nome}
                                                        </Typography>

                                                        <Typography
                                                            className={"StatusEstabelecimento"}
                                                            variant="body2"
                                                            component="p"
                                                        >
                                                            {Intl.NumberFormat("pt-BR", {
                                                                style: "currency",
                                                                currency: "BRL",
                                                            }).format(pedido.valorTotal)}
                                                        </Typography>
                                                    </Col>
                                                </Row>
                                            </CardActionArea>

                                            <CardActions
                                                style={{ cursor: "pointer", padding: "0" }}
                                            >
                                                <Typography
                                                    variant={"button"}
                                                    style={{ textAlign: "center", padding: "3px" }}
                                                    className={
                                                        pedido.valorDesconto
                                                            ? "botaoVerde naoArredondado"
                                                            : "botaoCinza naoArredondado"
                                                    }
                                                >
                                                    {pedido.valorDesconto
                                                        ? `DESCONTO DE ${Intl.NumberFormat(
                                                              "pt-BR",
                                                              { style: "currency", currency: "BRL" }
                                                          ).format(pedido.valorDesconto)}`
                                                        : `SEM DESCONTO`}
                                                </Typography>
                                            </CardActions>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        </Container>
                    </Dialog>
                )}

                {openEstabelecimentoDisponiveis && (
                    <Dialog
                        fullScreen
                        open={openEstabelecimentoDisponiveis}
                        onClose={handleCloseEstabelecimentoQueEntregam}
                        TransitionComponent={Transition}
                    >
                        <AppBar className={classes.appBar}>
                            <Toolbar>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={handleCloseEstabelecimentoQueEntregam}
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                                <Typography variant="h6" className={classes.title}>
                                    {!loadingEstabelecimentos
                                        ? "(" + listaEstabelecimentosQueDisponiveis.length + ")"
                                        : null}{" "}
                                    Estabelecimentos Encontrados
                                </Typography>
                            </Toolbar>
                        </AppBar>

                        <Container className={classes.appContainer}>
                            <Row>
                                {loadingEstabelecimentos ? (
                                    <>
                                        <Col
                                            xs={12}
                                            md={12}
                                            lg={12}
                                            style={{ marginBottom: "0.5em" }}
                                        >
                                            <Skeleton
                                                variant="rect"
                                                width={"100%"}
                                                height={48}
                                                style={{ marginBottom: "1em" }}
                                            />
                                        </Col>
                                        {listaRepeticao.map(chave => (
                                            <Col
                                                xs={12}
                                                md={6}
                                                lg={4}
                                                key={chave}
                                                style={{ marginBottom: "0.5em" }}
                                            >
                                                <Skeleton
                                                    variant="rect"
                                                    width={"100%"}
                                                    height={145}
                                                />
                                            </Col>
                                        ))}
                                    </>
                                ) : (
                                    <>
                                        <Col
                                            xs={12}
                                            md={12}
                                            lg={12}
                                            style={{ marginBottom: "0.5em" }}
                                        >
                                            <AlertFixo
                                                severity="warning"
                                                style={{ width: "100%", marginBottom: "1em" }}
                                            >
                                                {isDelivery ? (
                                                    <>
                                                        Você buscou estabelecimentos que entregam no
                                                        endereço <b>{carrinho?.end?.logradouro}</b>{" "}
                                                        de <b>{carrinho?.cliente?.nome}</b>.
                                                    </>
                                                ) : isRetiradaNoLocal ? (
                                                    `Você buscou estabelecimentos que aceitam retirada no local.`
                                                ) : (
                                                    `Você buscou estabelecimentos que aceitam pedidos na mesa.`
                                                )}
                                            </AlertFixo>
                                        </Col>
                                        {listaEstabelecimentosQueDisponiveis.length ? (
                                            listaEstabelecimentosQueDisponiveis.map(
                                                (estabelecimento, index) => (
                                                    <Col
                                                        xs={12}
                                                        md={6}
                                                        lg={4}
                                                        key={index}
                                                        style={{ marginBottom: "0.5em" }}
                                                    >
                                                        <Card
                                                            className={classes.root}
                                                            style={{ height: "100%" }}
                                                        >
                                                            <CardActionArea
                                                                onClick={() =>
                                                                    handleSelecionarEstabelecimento(
                                                                        estabelecimento,
                                                                        carrinho
                                                                    )
                                                                }
                                                                style={{
                                                                    flexFlow: "column-reverse",
                                                                    alignItems: "normal",
                                                                }}
                                                            >
                                                                <Row
                                                                    style={{
                                                                        margin: 0,
                                                                        textAlign: "",
                                                                        width: "100%",
                                                                        padding: "1em",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    <Col
                                                                        xs={3}
                                                                        md={3}
                                                                        lg={3}
                                                                        style={{ padding: 0 }}
                                                                    >
                                                                        <CardMedia
                                                                            component="img"
                                                                            className={"logoLojas"}
                                                                            alt={
                                                                                estabelecimento.nome
                                                                            }
                                                                            image={
                                                                                estabelecimento.urlLogo
                                                                            }
                                                                            title={
                                                                                estabelecimento.nome
                                                                            }
                                                                        />
                                                                    </Col>
                                                                    <Col xs={9} md={9} lg={9}>
                                                                        <Typography
                                                                            variant="body2"
                                                                            color="textSecondary"
                                                                            component="p"
                                                                        >
                                                                            {
                                                                                estabelecimento.endereco
                                                                            }
                                                                        </Typography>
                                                                        <Typography
                                                                            gutterBottom
                                                                            component="h2"
                                                                        >
                                                                            {estabelecimento.nome}
                                                                        </Typography>
                                                                    </Col>
                                                                </Row>
                                                            </CardActionArea>

                                                            <CardActions
                                                                style={{
                                                                    cursor: "pointer",
                                                                    padding: "0",
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant={"button"}
                                                                    style={{
                                                                        textAlign: "center",
                                                                        padding: "3px",
                                                                    }}
                                                                    className={
                                                                        estabelecimento.online
                                                                            ? "botaoVerde naoArredondado"
                                                                            : "botaoVermelho naoArredondado"
                                                                    }
                                                                    onClick={() =>
                                                                        handleSelecionarEstabelecimento(
                                                                            estabelecimento,
                                                                            carrinho
                                                                        )
                                                                    }
                                                                >
                                                                    {estabelecimento.online
                                                                        ? "Aberto"
                                                                        : estabelecimento.abreAs
                                                                        ? estabelecimento.abreAs
                                                                        : "Fechado"}{" "}
                                                                    -{" "}
                                                                    {isDelivery
                                                                        ? Intl.NumberFormat(
                                                                              "pt-BR",
                                                                              {
                                                                                  style: "currency",
                                                                                  currency: "BRL",
                                                                              }
                                                                          ).format(
                                                                              estabelecimento.taxaEntrega
                                                                          )
                                                                        : isRetiradaNoLocal
                                                                        ? "Aceita Retirada"
                                                                        : "Aceita Cliente Na Mesa"}
                                                                </Typography>
                                                            </CardActions>
                                                        </Card>
                                                    </Col>
                                                )
                                            )
                                        ) : (
                                            <Col
                                                xs={12}
                                                md={12}
                                                lg={12}
                                                style={{
                                                    textAlign: "center",
                                                    marginBottom: "0.5em",
                                                }}
                                            >
                                                <Typography>
                                                    {" "}
                                                    Nenhum estabelecimento foi encontrado.{" "}
                                                </Typography>
                                            </Col>
                                        )}
                                    </>
                                )}
                            </Row>
                        </Container>
                    </Dialog>
                )}

                <MesasAbertas />

                <VisualizarPedido />

                <FinalizarMesa />

                <ClientesEncontrados />

                {!idPedido && <EnderecosEncontrados />}

                {estabelecimentosDisponiveis.length === 1 && !cliente && !idPedido ? (
                    <ParteInicial iframe={iframe} />
                ) : (
                    estabelecimentosDisponiveis.length > 1 &&
                    !carrinho?.estabelecimento && <ParteInicial iframe={iframe} />
                )}

                {carrinho?.estabelecimento && <Cardapio iframe={iframe} />}

                <FormasDePagamento />

                {openFinalizacaoPedido && <FinalizacaoPedido iframe={iframe} />}

                <EditarCliente />

                <CadastrarCliente />

                <CadastrarEndereco />
            </Container>
        </RegistradorContext.Provider>
    )
}
